import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import MainLoader from '../../../components/Loaders/MainLoader';
import Error from '../../../components/errors/Error';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import CardStudent from '../../../components/cards/CardStudent';
import BtnContent from '../../../components/buttons/BtnContent';
//SLICE
import PublicLayout from '../../../layouts/PublicLayout';
import { getMatriculationProccesThunk } from '../../../store/slices/public/parents.slice';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import { getConfigsThunk } from '../../../store/slices/catalogs/config.slice';
import { getCoursesThunk } from '../../../store/slices/catalogs/courses.slice';
import { getAceptacionPoliticaThunk } from '../../../store/slices/public/aceptacionPoliticas.slice';
import { formatMonthYear } from '../../../utils/funtions';
import { Toast } from '../../../resources/utils';
import { initialStateReservacionCupo } from '../../../store/slices/public/reservacionCupo.slice';
import { Link } from 'react-router-dom';

const ProcessView = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, error } = useSelector(state => state.parents);
    const cupoState = useSelector(state => state.reservacion_cupo);
    const configurationsState = useSelector(state => state.configurations);
    const aceptacionState = useSelector(state => state.aceptacion_politicas)
    const courseState = useSelector(state => state.courses);
    const isLoading = useSelector(state => state.isLoadingSlice);
    const user = JSON.parse(localStorage.getItem("userInfo"));

    useEffect(() => {
        dispatch(getMatriculationProccesThunk(user.id));
        dispatch(getAceptacionPoliticaThunk(user.id))
        dispatch(getConfigsThunk());
        dispatch(getCoursesThunk());
    }, []);

    useEffect(() => {
        if (cupoState.message) {
            Toast.fire({
                icon: 'success',
                title: cupoState.message,
            }).then(() => {
                dispatch(getMatriculationProccesThunk(user.id));
                dispatch(initialStateReservacionCupo());
            })
        }
    }, [cupoState.message]);

    console.log(items)

    return (
        <PublicLayout>
            {isLoading ? <MainLoader /> : (
                <div className='w-full m-5'>
                    {error || cupoState.error ? <Error state={error || cupoState.error} /> : " "}
                    <HeaderForm title={t("Procesos de Matriculación")} />
                    {
                        !aceptacionState.item.isAcept ?
                            <div className='flex h-[90%] justify-center items-center'>
                                <div className='flex items-center justify-center gap-5 text-p-yellow'>
                                    <FaExclamationCircle size={50} />
                                    <div className='flex flex-col text-start'>
                                        <h2 className='text-xl font-semibold'>No se ha aceptado las políticas de privacidad</h2>
                                        <p className='text-p-blue'>
                                            Le informamos que, por razones de cumplimiento normativo y protección de datos,
                                        </p>
                                        <p className='text-p-blue'>
                                            la aceptación de las políticas de privacidad es un requisito indispensable para continuar con el proceso de matriculación.
                                        </p>
                                        <p className='text-p-blue mt-3'>  Por favor, revise y acepte las políticas para poder avanzar.</p>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-2 xl:grid-cols-3 2xl:gap-7.5 mt-5">
                                {
                                    items.map(item => (
                                        <CardStudent
                                            key={item.id}
                                            title={item.student?.nombre + ' ' + item.student?.apellido}
                                            background={'bg-slate-100'}
                                            student={item}
                                            configuration={configurationsState?.items[0]}
                                            courses={courseState?.items}
                                        >
                                            {
                                                item.student.active ?

                                                    item.cupo ?
                                                        item.matriculationEnd ?
                                                            <div className='flex flex-col gap-2 items-center justify-center m-4'>
                                                                <div className='flex items-center gap-2 text-xl'>
                                                                    <FaCheckCircle className='text-p-green' />
                                                                    <p className='font-semibold text-p-blue'>{t("El estudiante se encuentra matriculado")}</p>
                                                                </div>
                                                                <p>periodo {formatMonthYear(configurationsState.items[0]?.fecha_inicio_periodo_siguiente) + ' - ' + formatMonthYear(configurationsState.items[0]?.fecha_fin_periodo_siguiente)}</p>
                                                            </div>
                                                            :
                                                            configurationsState.items[0]?.habilitar_proceso_matriculacion ?
                                                                item.cupo.reserva_cupo === 'SI' ?
                                                                    <div className='flex flex-col items-center p-3 gap-5'>
                                                                        <div className='flex gap-2 items-center text-xl'>
                                                                            <FaCheckCircle className='text-p-green' />
                                                                            <p className='font-semibold text-p-blue'>{t("Cupo reservado")}</p>
                                                                        </div>
                                                                        <Link to={`/proceso_matriculacion/${item.ci_estudiante}`} className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-2 rounded-xl shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out">
                                                                            Continuar proceso de matriculación
                                                                        </Link>
                                                                    </div> :
                                                                    <p className='p-2'>😢 Sentimos que no puedas acompañarnos este nuevo año escolar 📚✨ ¡Te extrañaremos mucho! 💖</p>
                                                                :
                                                                <div className='flex gap-4 justify-center items-center text-sm p-2'>
                                                                    <FaExclamationCircle size={20} className='text-p-yellow' />
                                                                    <div className='text-start'>
                                                                        <p className='flex items-center gap-2 font-semibold text-p-blue'> El proceso de matriculación se habilitara</p>
                                                                        <p className='font-semibold text-p-blue'>{`desde ${formatMonthYear(configurationsState.items[0]?.fecha_inicio_matriculacion)} hasta ${formatMonthYear(configurationsState.items[0]?.fecha_fin_matriculacion)}`}</p>
                                                                    </div>
                                                                </div>
                                                        :
                                                        configurationsState.items[0]?.habilitar_reservacion_cupo ?
                                                            <div className='flex items-center justify-center p-3 w-full'>
                                                                <div className='flex items-center justify-start'>
                                                                    <button className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-2 rounded-xl shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out">
                                                                        <svg className="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" stroke-width="2"
                                                                            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                                d="M12 8c.379 0 .725.214.895.553l3.5 7A1 1 0 0115.5 17h-7a1 1 0 01-.895-1.447l3.5-7A1 1 0 0112 8z"></path>
                                                                        </svg>
                                                                        Reservar cupo
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className='flex gap-4 justify-center items-center text-sm p-2'>
                                                                <FaExclamationCircle size={20} className='text-p-yellow' />
                                                                <div className='text-start'>
                                                                    <p className='flex items-center gap-2 font-semibold text-p-blue'> El proceso de reservación de cupo se habilitara</p>
                                                                    <p className='font-semibold text-p-blue'>{`desde ${formatMonthYear(configurationsState.items[0]?.fecha_inicio_reservacion_cupo)} hasta ${formatMonthYear(configurationsState.items[0]?.fecha_fin_reservacion_cupo)}`}</p>
                                                                </div>
                                                            </div>

                                                    :
                                                    <div className='flex justify-center items-center h-24 p-2 gap-3 text-p-yellow'>
                                                        <FaExclamationCircle size={30} />
                                                        <p className='text-start'> Lamentamos que no puedas continuar con el proceso.<br/>
                                                            Te invitamos a comunicarte con el colegio para más información.
                                                        </p>
                                                    </div>
                                            }

                                        </CardStudent>
                                    ))
                                }
                            </div>
                    }
                </div>
            )}
        </PublicLayout>
    );
};

export default ProcessView;